import { theme } from "@src/theme";
import React from "react";

interface ProcessingBadgeProps {
  text: string;
  secondaryText: string;
  success: boolean;
  showError?: boolean;
}

const ProcessingBadge: React.FC<ProcessingBadgeProps> = ({
  text = "Processing",
  secondaryText = "mix",
  success = false,
  showError = false,
}) => {
  return (
    <div
      style={{
        display: "flex",
        position: "fixed",
        bottom: 0,
        height: 70,
        width: "100%",
      }}
    >
      <span
        style={{
          position: "absolute",
          height: 40,
          width: 250,
          textOverflow: "ellipsis",
          overflow: "hidden",
          whiteSpace: "nowrap",
          left: 32,
          borderRadius: 100,
          backgroundColor: showError
            ? theme.colors.red
            : success
              ? theme.colors.green
              : theme.colors.yellow,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: theme.colors.black,
          fontWeight: "bold",
          fontSize: 14,
          gap: 4,
        }}
        title={`${text} ${secondaryText}`}
      >
        <span
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: "inline-block",
            maxWidth: 220,
          }}
        >
          {text} <span style={{ fontWeight: "normal" }}>{secondaryText}</span>
        </span>
      </span>
      <div
        style={{
          display: "flex",
          position: "fixed",
          bottom: 0,
          height: 10,
          width: "100%",
          backgroundColor: showError
            ? theme.colors.red
            : success
              ? theme.colors.green
              : theme.colors.yellow,
          animation: success || showError ? "none" : "loadingBar 2s infinite",
        }}
      />
      <style>
        {`
            @keyframes loadingBar {
                0% { transform: translateX(-100%); }
                100% { transform: translateX(100%); }
            }
        `}
      </style>
    </div>
  );
};

export default ProcessingBadge;
